import * as React from 'react';
import ReactPaginate from 'react-paginate';

const Pagination = (props) => {
    const { pageCount, handlePageClick, setPageLimit, page, limit, isOrderModule, showFirstLabel = true, showLastLabel = true } = props

    return (
        <>
            <div className="pagination-row">
                <div className="pagination-wrapper">

                    <ul className="pagination pagination-sm m-0">
                        {showFirstLabel && (
                            <li className={(page === 0 ? "page-item disabled" : "page-item")}>
                                <a className='page-link' onClick={() => handlePageClick({ selected: 0 })}>
                                    First
                                </a>
                            </li>
                        )}

                        <ReactPaginate
                            breakLabel="..."
                            nextLabel={<i className='fa fa-caret-right'></i>}
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={2}
                            pageCount={pageCount}
                            previousLabel={<i className='fa fa-caret-left'></i>}
                            renderOnZeroPageCount={null}
                            containerClassName={"pagination pagination-sm m-0"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            activeClassName={"active"}
                            forcePage={page}
                        />

                        {showLastLabel && (
                            <li className={page >= (pageCount - 1) ? "page-item disabled" : "page-item"}>
                                <a className='page-link' onClick={() => handlePageClick({ selected: (pageCount - 1) })}>
                                    Last
                                </a>
                            </li>
                        )}
                    </ul>

                </div>
                <div className="page-size">
                    <label className="mb-0" htmlFor="ResultPerPage">Results Per Page:</label>
                    <span className="selectbox">
                        {isOrderModule ?
                            <select onChange={setPageLimit} value={parseInt(limit)} id="ResultPerPage">
                                <option value={40}>40</option>
                                <option value={80}>80</option>
                                <option value={120}>120</option>
                            </select> :
                            <select onChange={setPageLimit} value={parseInt(limit)} id="ResultPerPage">
                                <option value={20}>20</option>
                                <option value={40}>40</option>
                                <option value={60}>60</option>
                            </select>
                        }
                    </span>
                </div>
            </div>
        </>
    );
}

export default Pagination;